import { useEffect, useState } from "react";
import { AlertCircle, X } from "lucide-react";
import { useWallet } from "../contexts/WalletContext";
import { POLYGON_CHAIN_ID, getNetworkName } from "../config/web3Config";

export default function NetworkSwitcher() {
  const { isConnected, isCorrectNetwork, chainId, switchNetwork } = useWallet();
  const [show,      setShow]      = useState(false);
  const [switching, setSwitching] = useState(false);

  useEffect(() => {
    setShow(isConnected && !isCorrectNetwork);
  }, [isConnected, isCorrectNetwork]);

  if (!show) return null;

  const handle = async () => {
    try {
      setSwitching(true);
      await switchNetwork(POLYGON_CHAIN_ID);
    } catch {
      alert("Failed to switch network. Please switch manually in your wallet.");
    } finally {
      setSwitching(false);
    }
  };

  return (
    <div className="bg-yellow-50 border-b border-yellow-200">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <AlertCircle className="w-5 h-5 text-yellow-600 flex-shrink-0" />
            <div>
              <p className="text-sm font-medium text-gray-800">Wrong Network Detected</p>
              <p className="text-xs text-gray-600">
                You're on {getNetworkName(chainId)}. Please switch to Polygon Mainnet.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={handle}
              disabled={switching}
              className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors disabled:opacity-50"
            >
              {switching ? "Switching..." : "Switch to Polygon"}
            </button>
            <button onClick={() => setShow(false)} className="p-2 hover:bg-yellow-100 rounded-lg">
              <X className="w-4 h-4 text-gray-600" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
